import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';
import {sortByTextValue} from '@utils/sorters';

export const EncodingDatacentersFilter = ({
    encodingDatacenters = [],
    loading = false,
    filters,
    restoreFilterValues,
}) => (
    <Field
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        multiple
        name='encodingDatacenters'
        options={sortByTextValue(encodingDatacenters)}
        placeholder='Encoding datacenter'
        search
        selection
        setValue={restoreFilterValues(filters, 'encodingDatacenters') ?? ''}
    />
);

EncodingDatacentersFilter.propTypes = {
    encodingDatacenters: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
